import { Controller } from "@hotwired/stimulus";
import { mapEditedEventName } from "../../../../../../Components/Map/MapController";
import ViewOrEditFormController from "../../../../../../Components/ViewOrEditForm/ViewOrEditFormController";
import { DomEvents } from "../../../../../../scripts/_generated/DomEvents";

export default class IndoorTourGeographicalInformationController extends Controller {

    connect() {
        this.element.addEventListener(mapEditedEventName, this.onMapEdited.bind(this), {});
    }

    onMapEdited() {
        this.getViewOrEditFormController().edit();
        this.dispatch(DomEvents.tourDetailIndoorTourLocationEdited);
    }

    private getViewOrEditFormController(): ViewOrEditFormController {
        return this.application.getControllerForElementAndIdentifier($("form", this.element)[0], "view-or-edit-form") as ViewOrEditFormController;
    }
}